// import { login, logout, getInfo } from '@/api/user'
import { Login ,logout, getInfo } from 'api/login.js'
// import { getToken, setToken, removeToken } from '@/utils/auth'
import { getToken, setToken, removeToken,getBalance,setBalance,setPassword,getPassword } from '@/utils/auth-session'
import { resetRouter } from '@/router'
import { Message } from 'element-ui'
// Vuex 里面的state
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    code: '',
    balance:getBalance(),
    phone:getPassword(),
  }
}

const state = getDefaultState()

// 必须要用commit调用mutations里的方法，才能在store存储成功
const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },

  SET_CODE: (state, code) => {
    state.code = code
  },
  set_balance:(state,val) => {
    state.balance=val;
  },
  SET_Password:(state,val)=>{
          state.phone=val;
  },

}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { user, pwd } = userInfo
    // const { phone, password } = userInfo
    // console.log('登录时请求接口的数据userInfo: ', userInfo);
    return new Promise((resolve, reject) => {
      console.log('reject: ', reject);
      console.log('resolve: ', resolve);
      Login(user.trim(), pwd.trim()).then(response => {
        let timeMsg;
        if(response.code==1){
          let source= response.data.source.split(",")
          //  if(source.includes('4')){
          //    sessionStorage.setItem("wei_tuo",true)
          //  }else{
          //   sessionStorage.setItem("wei_tuo",false)
          //  }

          commit('SET_Password',pwd )
          setPassword(pwd)
          const { data } = response
          const TOKEN_RES = response.token
          const CMCODE_RES = data.cmCode
          const CMNAME_RES = data.cmName
          let Admin;
          if(response.admin){
            Admin = response.admin
            sessionStorage.setItem('admin',Admin)
          }else{
            sessionStorage.removeItem('admin')
          }
          commit('SET_TOKEN', TOKEN_RES)
          commit('SET_NAME', CMNAME_RES)
          commit('SET_CODE', CMCODE_RES)
          setToken(TOKEN_RES)
          localStorage.setItem('name',CMNAME_RES)
          localStorage.setItem('code',CMCODE_RES)

          if(typeof (data.balance)!="undefined"){
           let b=data.balance
            setBalance(b)
            commit('set_balance',b)


          }


        }else if(response.code==0){
          timeMsg = response.info;
          Message({ message: timeMsg, duration: 2 * 1000 ,type: 'error',});
          console.log('賬號或密碼錯誤')
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response
  //       console.log('getInfo-response: ', response)

  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }
  //       // code 用户的編號  name 动态判断为哪一个用户
  //       const { name, code } = data
  //       // 此处验证用户信息中是否存在name
  //       commit('SET_NAME', name)
  //       commit('SET_CODE', code)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // user logout  已废弃
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     logout(state.token).then(() => {
  //       removeToken() // must remove  token  first
  //       resetRouter()
  //       commit('RESET_STATE')
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // remove token 已废弃
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,//在不同页面中引入getter、actions、mutations时，需要加上所属的模块名
  state,
  mutations,
  actions
}

